import React from 'react'

function GetNavList(config) {
  const NavList = []
  if (config.navLinks) {
    config.navLinks.forEach(link => {
      NavList.push({
        primaryText: link.label,
        leftIcon: <i className={link.iconClassName}></i>,
        component: 'Link',
        to: link.url,
      })
    })
  }

  return NavList
}
export default GetNavList
